module.exports = __webpack_public_path__ + "img/dating-sharow-left.e807ab2.png";